import { Children, ReactElement, ReactNode, cloneElement } from 'react'

export default function joinChildren(children: ReactNode, separator: ReactElement) {
  const array = Children.toArray(children)

  return array.length
    ? array.reduce((prev, current, index) => [
        prev,
        cloneElement(separator, { key: index }),
        current,
      ])
    : children
}
